<template>
    <transition name="product-slide">
        <div class="col-xs-12 col-md-6 col-lg-4 product-item" v-if="active">
            <slot></slot>
        </div>
    </transition>
</template>

<style lang="sass">

    @import ../../common/styles/settings

    .product-slide
        &-enter-active,
        &-leave-active
            transition: opacity $speed-normal $authentic-motion, transform $speed-normal $authentic-motion

            @for $i from 1 through 9
                &:nth-child(#{$i})
                    transition-delay: calc($speed-fast/4) * $i, calc($speed-fast/4) * $i

        &-enter
            opacity: 0
            transform: translateY(1rem)

        &-enter-to,
        &-leave
            opacity: 1
            transform: none

        &-leave-to
            opacity: 0
            transform: translateY(-1rem)

</style>

<script>
import { ref, inject, onMounted } from 'vue';

export default {
  props: {
    flags: {
      type: Array,
      default: () => []
    }
  },
  setup(props) {
    const active = ref(true);
    const registerProduct = inject("registerProduct", null);

    // Methods
    const toggleDisplay = (filters) => {
      const intersect = props.flags.filter(f => filters.includes(f));
      active.value = filters.length > 0 ? intersect.length > 0 : true;
    };

    onMounted(() => {
      if (registerProduct) {
        registerProduct({
          active,
          toggleDisplay
        });
      }
    });

    return {
      active,
      toggleDisplay
    };
  }
}
</script>

